export enum ServiceNames {
  FOLDER = 'FolderService',
  CHANNEL = 'ChannelService',
  CASE = 'CaseService',
  ENTITY = 'EntityService',
  AUDIT = 'AuditService',
  FLOW = 'FlowService',
  GROUP = 'GroupService',
  LIST = 'ListService',
  ROLE = 'RoleService',
  USER = 'UserService',
  COMPONENT = 'ComponentService',
  LIST_DATA = 'ListDataService',
  BASIC_VARIABLE = 'BasicVariableService',
  QUERY_VARIABLE = 'QueryVariableService',
  LIST_VARIABLE = 'ListVariableService',
  API_VARIABLE = 'ApiVariableService',
  VELOCITY_VARIABLE = 'VelocityVariableService',
  CONNECTION = 'ConnectionService',
  DOMAIN_CONFIGURATION = 'DomainConfigurationService',
  STRUCT = 'StructService',
  SANDBOX = 'SandboxService',
  DRAGGABLE_ITEM = 'DraggableItemsService',
  STREAM = 'StreamService',
  ACTION = 'ActionService',
  JOB = 'JobService',
  WATCHLIST = 'WatchlistService',
  CUSTOM_LIST = 'CustomListService',
  EXPRESSION_BRIDGE = 'ExpressionBridge',
  NOTIFICATION_SERVICE = 'NOTIFICATION_SERVICE',
  GRAPH = 'GraphService',
  CHART = 'ChartService',
  DASHBOARD = 'DashboardService',
  AI_MODEL = 'AiModelService',
  ENRICHMENT = 'EnrichmentService',
  TRACKER = 'Tracker',
  CRA = 'CraService',
  ACH = 'AchService'
}
